// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import "./../../bindings/bao-tabs";
function TicketAbonnementDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.Focus = function () { };
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        // if (isComplete == false) {
        //     new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        // }
        return isComplete;
    };
    self.Show = function (ticketAbonnementId) {
        tabPage.IsLoading(true);
        $.when(Bao.post("TicketAbonnement/ShowTicketAbonnementDialog", JSON.stringify({
            ticketAbonnementId: ticketAbonnementId
        }))).then(function (value) {
            ko.map.fromJS(value[0].Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value[0].Message);
            self.Dialog.Open();
            self.DialogViewModel.Focus();
            tabPage.IsLoading(false);
        });
    };
}
export default TicketAbonnementDialog;